var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 471,
    viewBox: "0 0 407 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1246 26.8103C65.1467 4.64728 90.4864 -6.53271 108.894 6.17551L484.08 265.2C503.388 278.529 500.611 307.864 479.146 317.335L42.3627 510.046C20.8978 519.516 -2.64172 501.791 0.528024 478.545L62.1246 26.8103Z",
    fill: "#E9DDDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle3);
export default __webpack_public_path__ + "static/media/triangle3.622060bb8ca609408e26ace2d5f7e80a.svg";
export { ForwardRef as ReactComponent };